exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-enter-active,\n.page-leave-active {\n\t-webkit-transition: opacity .2s;\n\ttransition: opacity .2s;\n}\n.page-enter,\n.page-leave-to {\n\topacity: 0;\n}\n.fade-enter-active,\n.fade-leave-active {\n\t-webkit-transition: opacity .15s;\n\ttransition: opacity .15s\n}\n.fade-enter,\n.fade-leave-to {\n\topacity: 0\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-617ab0be","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/App.vue
// module id = l/Eb
// module chunks = 1